import { createSelector } from '@reduxjs/toolkit';

import { MESSAGES } from '../../../constants';
import { ILiveChatChangeMode } from '../../common/messageCreators';
import { selectConversationId, selectIsAiEnabled, selectItems } from '../../common/selectors/chat';
import { selectFieldNodeId } from '../../common/selectors/field';
import {
  selectArticle,
  selectCurrentCategory,
  selectCurrentPresentedState,
  selectFullPageSidebarExtended,
  selectFullPageSidebarOpened,
  selectPreviousPresentedState,
  selectSearchedText,
  selectSearchSessionId,
} from '../../common/selectors/helpCenter';
import { selectRecommendedArticles } from '../../common/selectors/homepage';
import { selectIntentId, selectMainOptionName, selectOrigParams } from '../../common/selectors/meta';
import { getChatbotSendButtonId } from '../constants';

const selectTicketId = createSelector(selectItems, (items) => {
  const changeModeItem = items.find((item) => item.type === MESSAGES.CHANGE_MODE) as
    | ILiveChatChangeMode
    | undefined;

  return changeModeItem?.ticketId;
});

export const selectBiData = createSelector(
  selectTicketId,
  selectCurrentCategory,
  selectConversationId,
  selectFieldNodeId,
  selectIntentId,
  selectMainOptionName,
  selectOrigParams,
  selectCurrentPresentedState,
  selectPreviousPresentedState,
  selectSearchedText,
  selectSearchSessionId,
  selectArticle,
  selectFullPageSidebarOpened,
  selectFullPageSidebarExtended,
  selectRecommendedArticles,
  selectIsAiEnabled,
  (
    ticketId,
    currentCategory,
    conversationId,
    nodeId,
    intentId,
    mainOptionName,
    origParams,
    currentPresentedState,
    previousPresentedState,
    searchedText,
    searchSessionId,
    article,
    fullPageSidebarOpened,
    fullPageSidebarExtended,
    recommendedArticles,
    isAiEnabled,
  ) => {
    const categoryId = currentCategory
      ? currentCategory.children && currentCategory.children.length > 0
        ? currentCategory.children[0].parentId
        : currentCategory.id
      : undefined;

    return {
      categoryId,
      conversationId,
      nodeId,
      intentId,
      mainOptionName,
      currentPresentedState,
      previousPresentedState,
      fullPageSidebarOpened,
      fullPageSidebarExtended,
      ticketId,
      searchedText: searchedText || undefined,
      searchSessionId,
      origPageName: origParams.origPageName,
      origPlatform: origParams.origPlatform,
      articleId: article?.id,
      articleRecommendationVersion: recommendedArticles.data?.modelId,
      buttonId: getChatbotSendButtonId(isAiEnabled),
    };
  },
);
